import React from "react";
import { ToastContainer } from "react-toastify";
import ViewProduct from "../../components/ProductManager/Product/ViewProduct";

export const ViewProductPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewProduct />
        </div>
      </div>
    </div>
  );
};
